class Animator {
  constructor(simulationStepCallback, animationStepCallback, params) {
    this.simulationStepCallback = simulationStepCallback;
    this.animationStepCallback = animationStepCallback;

    this.stepTimeMs = params.stepTimeMs;
    this.haltThresholdMs = params.haltThresholdMs;
  }

  start() {
    this.lastStepTime = performance.now();
    window.requestAnimationFrame(this.handleAnimationFrame.bind(this));
  }

  handleAnimationFrame(time) {
    let timeDifference = (time - this.lastStepTime);
    let stepsReached = Math.floor(timeDifference / this.stepTimeMs);

    if (timeDifference < this.haltThresholdMs) {
      for (let i = 0; i < stepsReached; i++) {
        this.simulationStepCallback();
      }
    }

    this.lastStepTime += (stepsReached * this.stepTimeMs);
    this.animationStepCallback();

    window.requestAnimationFrame(this.handleAnimationFrame.bind(this));
  }
}

export default Animator;



// WEBPACK FOOTER //
// ./src/visuals/Animator.js